var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import defaultTheme from '../themes/default';
export var ThemeContext = React.createContext({ theme: defaultTheme });
export var ThemeProvider = function (_a) {
    var children = _a.children, value = _a.value;
    return _jsx(ThemeContext.Provider, __assign({ value: value }, { children: children }));
};
